import React from "react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import { fr } from "date-fns/locale/fr";
import "react-datepicker/dist/react-datepicker.css";
import {
  isoToDate,
  getNextDay,
  getPrevDay,
} from "../../../utils/activeFiresDateUtils";
import makeCustomHeader from "../../atoms/activeFiresDatePickerHeader/ActiveFiresDatePickerHeader";
import ActiveFiresTimeline from "../activeFiresTimeline/ActiveFiresTimeline";
import "./ActiveFiresContent.css"
registerLocale("fr", fr);

// Data is historic-only (no forecast), so nothing after today can ever be picked.
const today = new Date();

const capToToday = (date) => {
  if (!date) return today;
  return date > today ? today : date;
};

const ActiveFiresContent = ({
  displayStartDate,
  displayEndDate,
  onStartDateChange,
  onEndDateChange,
  onApply,
  onCancel,
  detectedCount,
  isLoading,
  selectedPreset,
  onPreset,
  persoDisabled,
  isSmallScreen,
  isLayerActive,
  timelineHours,
  timelineCursor,
  onTimelineCursorChange,
  timelineBuckets,
  onToggleLayer,
}) => {
  const canApply = !!selectedPreset;

  return (
    <div className="afp-content">
      <div className="afp-presets afp-perso-row">
        <button
          type="button"
          className={`afp-preset-btn ${
            selectedPreset === "perso" ? "active" : ""
          }`}
          onClick={() => onPreset("perso")}
          disabled={persoDisabled}
        >
          Choisir une période
        </button>
      </div>

      <div className="afp-dates">
        <DatePicker
          selected={isoToDate(displayStartDate)}
          onChange={(date) => onStartDateChange(date)}
          locale="fr"
          dateFormat="dd/MM/yyyy"
          placeholderText="jj/mm/aaaa"
          className="afp-date-input"
          wrapperClassName="w-100"
          isClearable
          {...(isSmallScreen
            ? { withPortal: true, portalId: "afp-datepicker-portal" }
            : {})}
          maxDate={capToToday(getPrevDay(isoToDate(displayEndDate)))}
          renderCustomHeader={makeCustomHeader((date) =>
            onStartDateChange(date),
          )}
        />
        <span className="afp-date-sep">-</span>
        <DatePicker
          selected={isoToDate(displayEndDate) || today}
          onChange={(date) => onEndDateChange(date)}
          locale="fr"
          dateFormat="dd/MM/yyyy"
          placeholderText="jj/mm/aaaa"
          className="afp-date-input"
          wrapperClassName="w-100"
          isClearable
          {...(isSmallScreen
            ? { withPortal: true, portalId: "afp-datepicker-portal" }
            : {})}
          minDate={getNextDay(isoToDate(displayStartDate))}
          maxDate={today}
          renderCustomHeader={makeCustomHeader((date) => onEndDateChange(date))}
        />
      </div>

      <div className="afp-presets">
        {[
          { key: "7jours", label: "- 7 jours" },
          { key: "72h", label: "- 72h" },
          { key: "24h", label: "- 24h" },
          { key: "maintenant", label: "Maintenant" },
        ].map((p) => (
          <button
            key={p.key}
            type="button"
            className={`afp-preset-btn ${
              selectedPreset === p.key ? "active" : ""
            }`}
            onClick={() => onPreset(p.key)}
          >
            {p.label}
          </button>
        ))}
      </div>
      {timelineHours > 0 && selectedPreset !== "maintenant" && (
        <ActiveFiresTimeline
          hours={timelineHours}
          cursor={timelineCursor}
          onCursorChange={onTimelineCursorChange}
          buckets={timelineBuckets}
          onToggleLayer={onToggleLayer}
          isLayerActive={isLayerActive}
        />
      )}
      {/* Footer */}
      <div className="afp-footer">
        <span className="afp-count">
          {isLoading
            ? "Chargement…"
            : detectedCount !== null && detectedCount !== undefined
              ? `${detectedCount} foyers détectés`
              : ""}
        </span>
        <div className="afp-actions">
          <button
            type="button"
            className="historic-masquer-btn"
            onClick={onCancel}
            disabled={!isLayerActive}
          >
            Masquer
          </button>
        </div>
      </div>
      {/* Data attribution — required by LSA SAF CC BY 4.0 license */}
      <div className="afp-attribution">
        Source : EUMETSAT LSA SAF, MTG Fire Radiative Power Pixel Product, MTG
        FRP-Pixel, LSA-509 —{" "}
        <a
          href="https://lsa-saf.eumetsat.int/en/data/data-access/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LSA SAF usage policy and acknowledgement
        </a>
      </div>
    </div>
  );
};

export default React.memo(ActiveFiresContent);
